function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 1,
  y1: 1,
  x2: 0,
  y2: -0.011,
  gradientUnits: "objectBoundingBox"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#6a18ac"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#f07097"
})), React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 1.075,
  y1: 1.047,
  y2: 0,
  xlinkHref: "#linear-gradient"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Brain",
  transform: "translate(-1051 -228)"
}, React.createElement("path", {
  id: "Brain_Part",
  "data-name": "Brain Part",
  d: "M25.029,123.444A23.436,23.436,0,0,1,8,101.111a22.727,22.727,0,0,1,3.08-11.444A22.974,22.974,0,0,1,9.614,51.322a23.348,23.348,0,0,1,21.72-31.877c.223,0,.445,0,.667.009v-.009C32,8.706,40.955,0,52,0S72,8.706,72,19.444v97.222C72,129.553,61.255,140,48,140A23.935,23.935,0,0,1,25.029,123.444Z",
  transform: "translate(1051 228)",
  fill: "url(#linear-gradient)"
}), React.createElement("path", {
  id: "Brain_Part-2",
  "data-name": "Brain Part",
  d: "M32,120.556v-.009c-.222.006-.444.009-.667.009A23.348,23.348,0,0,1,9.614,88.679,22.974,22.974,0,0,1,11.08,50.333,22.727,22.727,0,0,1,8,38.889,23.437,23.437,0,0,1,25.029,16.555,23.935,23.935,0,0,1,48,0C61.255,0,72,10.447,72,23.333v97.222C72,131.295,63.046,140,52,140S32,131.295,32,120.556Z",
  transform: "translate(1192.944 368) rotate(180)",
  fill: "url(#linear-gradient-2)"
}), React.createElement("path", {
  id: "Line",
  d: "M566,448a16,16,0,0,1-16,16",
  transform: "translate(556.222 -142.5)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2
}), React.createElement("path", {
  id: "Line-2",
  "data-name": "Line",
  d: "M550,448a16,16,0,0,0,16,16",
  transform: "translate(571.723 -176.406)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2
}), React.createElement("path", {
  id: "Line-3",
  "data-name": "Line",
  d: "M550,448a24,24,0,0,0,24,24",
  transform: "translate(508 -177.467)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2
}), React.createElement("path", {
  id: "Line-4",
  "data-name": "Line",
  d: "M574,472a24,24,0,0,0-24-24",
  transform: "translate(612.945 -140.734)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2
}));

var SvgBrain = function SvgBrain(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 141.944,
    height: 140,
    viewBox: "0 0 141.944 140",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBrain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Brain.7e8b6fae.svg";
export { ForwardRef as ReactComponent };